import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterModule } from '@commons/footer/footer.module';
import { HeaderModule } from '@commons/header/header.module';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { ProfileUnloggedModule as ProfileDomainModule } from '@domains/profile-unlogged/profile-unlogged.module';
import { LayoutComponent } from '@features/profile-unlogged/layout/layout.component';
import { ViewComponent } from '@features/profile-unlogged/view/view.component';
import { ProfileUnloggedRoutingModule } from '@routing/profile-unlogged/profile-unlogged-routing.module';
import { CompanyStoreModule } from '@store/company/company.store.module';
import { SearchCompaniesStoreModule } from '@store/search/companies/search-companies.store.module';
import { HeadDescriptionModule, HeadTitleModule } from '@wizbii/seo-lib';

@NgModule({
  imports: [
    CommonModule,
    ProfileUnloggedRoutingModule,
    HeaderModule,
    ProfileDomainModule,
    SvgIconModule,
    CompanyStoreModule,
    SearchCompaniesStoreModule,
    FooterModule,
    HeadTitleModule,
    HeadDescriptionModule,
  ],
  declarations: [LayoutComponent, ViewComponent],
})
export class ProfileUnloggedModule {}
